module.exports = __webpack_public_path__ + "img/202306_10.31cde28b.jpg";